<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import SupportHead from './_SupportHead.vue'
import SupportMethods from './_SupportMethods.vue'
import SupportFooter from './_SupportFooter.vue'

import locator from '@/service-locator'
import { maskPhoneNumber } from '@/utils/logger'

export default {
  name: 'SidebarSupportWidget',
  components: {
    SupportHead,
    SupportMethods,
    SupportFooter,
  },
  data() {
    return {
      status: '',
    }
  },
  computed: {
    ...mapState('merchantSupport', ['submitting']),
    ...mapGetters('userProfile', ['selectedMerchant']),
    ...mapGetters('profile', { merchantProfile: 'profile' }),
    isT3Merchant() {
      const tier = this.merchantProfile?.tier?.tier || ''

      return ['Tier 3', 'T3', 'Tier 3 - Unverified Pilot'].includes(tier)
    },
    supportCallbackVisible() {
      return (
        this.merchantProfile.country.toLowerCase() === 'ae' && this.isT3Merchant
      )
    },
  },
  methods: {
    ...mapActions('merchantSupport', ['submitCallbackRequest']),
    handleChatWithUs() {
      locator.chatbot.openChatbot()
    },
    async handleSubmitCallback(data) {
      this.status = 'submitting'

      try {
        await this.submitCallbackRequest({
          merchantId: this.selectedMerchant,
          ...data,
        })

        this.status = 'success'
      } catch (error) {
        this.$logger.noticeError(error, {
          merchantId: this.selectedMerchant,
          phoneNumber: maskPhoneNumber(data.phoneNumber),
        })

        this.status = 'failed'
      }
    },
  },
}
</script>

<template>
  <div class="sidebar-support-widget is-lavender-design">
    <SupportHead />
    <SupportMethods
      class="mt-6"
      :submitting="submitting"
      :status="status"
      :support-callback-visible="supportCallbackVisible"
      @click:chat-with-us="handleChatWithUs"
      @click:submit-callback="handleSubmitCallback"
    />
    <SupportFooter class="mt-4" />
  </div>
</template>

<style lang="scss" scoped>
.sidebar-support-widget {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;
  background-color: var(--tamara-color-background-neutral-mid);
  border-radius: 8px;
}
</style>
